import _objectSpread from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serverChanner } from "@/mixins/index";
import Editor from "@/components/Editor";
export default {
  components: {
    Editor: Editor
  },
  mixins: [serverChanner],
  data: function data() {
    return {
      form: {
        language: "",
        content: "",
        date: [],
        id: "",
        channel: "",
        state: 1
      },
      formMark: {},
      dialogShow: false,
      rules: {
        date: [{
          required: true,
          message: "请选择时间",
          trigger: "blur"
        }],
        content: [{
          required: true,
          message: "请输入内容",
          trigger: "blur"
        }],
        state: [{
          required: true,
          message: "请选择状态",
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }],
        channel: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    this.formMark = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var k;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  for (k in _this.formMark) {
                    _this.form[k] = data[k];
                  }

                  _this.form.date = [data.start_show_time, data.end_show_time];
                  _this.form.content = _this.$utils.textRepl(data.content);
                }

                _this.dialogShow = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onEditorChange: function onEditorChange(e) {
      this.form.content = e;
    },
    clearData: function clearData(id) {
      this.form = _objectSpread({}, this.formMark);
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.form));
          data.start_show_time = data.date[0];
          data.end_show_time = data.date[1];
          delete data.date;
          data.content = data.content.replaceAll(_this2.$imgUrl, '');
          var reqFn = _this2.form.id ? 'loginBeforeAnnounceUpdate' : 'loginBeforeAnnounceAdd';

          _this2.$api[reqFn](data).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$emit('change');
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};